"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuOrderDiscountToJSON = exports.MenuOrderDiscountFromJSONTyped = exports.MenuOrderDiscountFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MenuOrderDiscountFromJSON(json) {
    return MenuOrderDiscountFromJSONTyped(json, false);
}
exports.MenuOrderDiscountFromJSON = MenuOrderDiscountFromJSON;
function MenuOrderDiscountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': json['label'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'code': !(0, runtime_1.exists)(json, 'code') ? undefined : json['code'],
        'amount': json['amount'],
        'priority': !(0, runtime_1.exists)(json, 'priority') ? undefined : json['priority'],
        'expiresAt': !(0, runtime_1.exists)(json, 'expiresAt') ? undefined : json['expiresAt'],
        'origin': (0, _1.OrderDiscountOriginFromJSON)(json['origin']),
        'type': (0, _1.OrderDiscountTypeFromJSON)(json['type']),
        'reference': !(0, runtime_1.exists)(json, 'reference') ? undefined : json['reference'],
    };
}
exports.MenuOrderDiscountFromJSONTyped = MenuOrderDiscountFromJSONTyped;
function MenuOrderDiscountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'label': value.label,
        'description': value.description,
        'code': value.code,
        'amount': value.amount,
        'priority': value.priority,
        'expiresAt': value.expiresAt,
        'origin': (0, _1.OrderDiscountOriginToJSON)(value.origin),
        'type': (0, _1.OrderDiscountTypeToJSON)(value.type),
        'reference': value.reference,
    };
}
exports.MenuOrderDiscountToJSON = MenuOrderDiscountToJSON;
